import handleStep1 from './step1';
import handleStep2 from './step2';
import handleStep3 from './step3';
import handleStep4 from './step4';

export function handleStep() {
  if (document.getElementById('creation-step-1')) {
    handleStep1();
  }
  if (document.getElementById('creation-step-2')) {
    handleStep2();
  }
  if (document.getElementById('creation-step-3')) {
    handleStep3();
  }
  if (document.getElementById('creation-step-4')) {
    handleStep4();
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/index.js